import { ObservableLocalStorageVariable, ObservableVariable } from '@lexriver/observable'
import {TypeEvent, TypeEventResult} from '@lexriver/type-event'
import { EnumSwipeType } from './enums/EnumSwipeType'

export module GlobalState{

    let _currentUrl:string = ''

    export function getCurrentUrl(){
        return _currentUrl
    }
    export const eventPageChange = new TypeEvent<(url:string, pageContent:HTMLElement)=>TypeEventResult>()
    eventPageChange.subscribe((url, pageContent) => {
        _currentUrl = url
    })
    export const eventSwipe = new TypeEvent<(swipeType:EnumSwipeType)=>TypeEventResult>()

    export let basketSmallDiv:HTMLDivElement

    export const onScrollEvent = new TypeEvent<()=>TypeEventResult>()

    // export const productDisplayType = new ObservableLocalStorageVariable<string>({
    //     localStorageKey: 'productDisplayType',
    //     defaultValueIfNotInLocalStorage: EnumProductDisplayType.Tiles,
    //     //validatorFunction: (x) => Data.isValueExistsInEnum(x, EnumProductDisplayType),
    // })

    export const productShowDescriptionO = new ObservableLocalStorageVariable<boolean>({
        localStorageKey: 'productShowDescription',
        defaultValueIfNotInLocalStorage: false
    })

    export const productShowNameO = new ObservableLocalStorageVariable<boolean>({
        localStorageKey: 'productShowName',
        defaultValueIfNotInLocalStorage: true
    })

    export const productShowSkuO = new ObservableLocalStorageVariable<boolean>({
        localStorageKey: 'productShowSku',
        defaultValueIfNotInLocalStorage: false
    })

    export const productShowTypeO = new ObservableLocalStorageVariable<boolean>({
        localStorageKey: 'productShowType',
        defaultValueIfNotInLocalStorage: false
    })

    export const productShowZeroQuantityProductsO = new ObservableLocalStorageVariable<boolean>({
        localStorageKey: 'productShowZeroQuantity',
        defaultValueIfNotInLocalStorage: false
    })

    export const topBarSearchIsVisibleO = new ObservableVariable<boolean>(false)

    export const productShowHiddenProductsO = new ObservableLocalStorageVariable<boolean>({
        localStorageKey: 'productShowHidden',
        defaultValueIfNotInLocalStorage: true
    })



    
}